import { createContext, useContext, useState } from 'react';
import Loader from '../../components/loader';
import './style.scss';

const LoaderContext = createContext();

function LoaderProvider({ children }) {
  const [active, setActive] = useState(false);

  async function show(show) {
    setActive(show);
    const root = document.querySelector(':root');
    root.style.setProperty('overflow', show ? 'hidden' : 'unset', 'important');
    root.style.setProperty(
      '--backdrop-top',
      `${document.documentElement.scrollTop}px`
    );
  }

  function setDefault() {
    setActive(false);
  }

  return (
    <LoaderContext.Provider value={{ active, show, setDefault }}>
      {active ? (
        <div className='backdrop'>
          <Loader></Loader>
        </div>
      ) : null}
      {children}
    </LoaderContext.Provider>
  );
}

function useLoader() {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error('useLoader must be used within a LoaderProvider');
  }
  return context;
}

export { LoaderProvider, useLoader };
